import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { Lead } from "../../dtos/lead.viewmodel";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { MarketingService } from "./../../services/marketing/marketing.service";
import { ProjectsService } from "./../../services/projects/projects.service";
import { ErrorHandlerService } from "./../../services/shared/error-handler.service";
import { UserServiceService } from "./../../services/user-service/user-service.service";

@Component({
  selector: "addlead",
  templateUrl: "./addlead.component.html",
  styleUrls: ["./addlead.component.css"],
  providers: [LeadsService],
})
export class AddLeadComponent {
  title = "addlead";

  lead: any = null;
  leadSources: Array<any> = [];
  agents: any;
  brokers: Array<any> = [];
  ambassadors: Array<any> = [];
  leadId;
  leadDetails = [];
  private sub: any;
  genderId: any;
  genders: Array<any> = [{ text: "Male" }, { text: "Female" }];
  roleId;
  role: any;
  data: Array<any> = [];
  currentEmailValid = true;
  errortext: boolean;
  userData: any;
  defineRule: any;
  channels: any;
  channel: any;
  projects: any;
  types: any;
  channelview: any;

  disable_submit_button = false;

  arrSearch: any = [];
  dataFromSearch: any;

  selectedCar: number;

  cars = [
    { id: 1, name: "Volvo" },
    { id: 2, name: "Saab" },
    { id: 3, name: "Opel" },
    { id: 4, name: "Audi" },
  ];

  id_types = ["passport", "id"];

  events: any = [];

  nationalities: any = [];

  constructor(
    private leadsService: LeadsService,
    private route: ActivatedRoute,
    private router: Router,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private marketingService: MarketingService,
    private projectsService: ProjectsService,
    private userService: UserServiceService,
    public http: HttpClient,
    private reservationService: ReservationService
  ) {
    this.userData = JSON.parse(window.localStorage.getItem("userProfile"));
    this.lead = new Lead();
    this.lead.gender = "Male";
    this.leadSource();
    if (
      this.userData.role == "Admin" ||
      this.userData.role == "CFO" ||
      (this.userData.is_sales_team && this.userData.is_arm)
    ) {
      this.getBrokers();
    }
  }

  ngOnInit() {
    this.getNationalities();
    // this.getBrokers();
    this.getAmbassadors();
    this.getEvents();
    this.getChannels();
    this.getProjects();
    this.getTypes();
    this.sub = this.route.params.subscribe((params) => {
      this.leadId = +params["id"]; // (+) converts string 'id' to a number
      if (this.leadId > 0) {
        this.getLeadDetails();
      } else {
        this.clearControls();
      }
    });

    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        console.log(data);
        console.log(this.lead.user_ids);
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  save() {
    this.slimLoadingBarService.start();
    this.errortext = null;

    // this.lead.agent_id =
    //   this.lead.agent_id && this.lead.agent_id != -1
    //     ? this.lead.agent_id.id
    //     : "";
    console.log(this.lead.user_ids);

    if (this.leadId) {
      if (this.channel) {
        this.lead.lead_channel_id = this.channel;
      }
      if (this.lead.lead_source) {
        this.disable_submit_button = true;
        this.leadsService.editALead(this.leadId, this.lead).subscribe(
          (data) => {
            console.log(data);
            this.slimLoadingBarService.complete();
            swal("Woohoo!", "Lead updated succesfully!", "success").then(
              (value) => {
                this.router.navigate(["pages/leads"]);
              }
            );
            this.disable_submit_button = false;
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.errortext = err._body;
            this.slimLoadingBarService.complete();
            this.disable_submit_button = false;
            console.log(err);
            if (err.error.message == "Lead already exists with you") {
              if (!isNaN(err.error.leadId)) {
                this.router.navigate([`/pages/leads/${err.error.leadId}`]);
              }
            }
          }
        );
      } else {
        swal("Lead source is required", "", "error");
      }
    } else {
      this.lead.lead_channel_id = this.channel;
      if (this.lead.lead_source) {
        this.disable_submit_button = true;
        this.leadsService.createLead(this.lead).subscribe(
          (data) => {
            console.log(data);
            this.slimLoadingBarService.complete();
            swal("Woohoo!", "Lead created succesfully!", "success").then(
              (value) => {
                this.router.navigate(["pages/leads"]);
              }
            );
            this.disable_submit_button = false;
          },
          (err) => {
            this.errortext = err._body;
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
            this.disable_submit_button = false;
            console.log(err);
            if (err.error.message == "Lead already exists with you") {
              if (!isNaN(err.error.leadId)) {
                this.router.navigate([`/pages/leads/${err.error.leadId}`]);
              }
            }
          }
        );
      } else {
        swal("Lead source is required", "", "error");
      }
    }
  }

  calculatesChannelAndSources(channel_id, leadSource) {
    console.log(channel_id, leadSource, this.channels);
    this.channel = channel_id;
    if (Array.isArray(this.require_channels)) {
      this.require_channels.push(() => {
        this.channels.forEach((channel) => {
          if (channel.id == channel_id) {
            this.leadSources = channel.sources;
          }
          this.lead.lead_source = leadSource;
        });
      });
    } else {
      this.channels.forEach((channel) => {
        if (channel.id == channel_id) {
          this.leadSources = channel.sources;
        }
        this.lead.lead_source = leadSource;
      });
    }
  }

  leadSource() {
    var data = this.leadsService.leadSource();
  }

  getLeadDetails() {
    if (this.lead.broker_id === null) {
      this.lead.broker_id = 1;
    }
    if (
      this.lead.lead_source === null ||
      this.lead.lead_source == "Self Generate"
    ) {
      this.lead.lead_source = "Self Generate";
    }
    // if (this.lead.agent_id === null) {
    //   this.leadId.agent_id = 0;
    // }
    this.slimLoadingBarService.start();
    this.leadsService.getLeadDetails(this.leadId).subscribe(
      (data: any) => {
        console.log(data);
        this.lead.name = data.lead.name;
        this.lead.phone = data.lead.phone;
        this.lead.email = data.lead.email;
        this.lead.gender = data.lead.gender;
        this.lead.occupation = data.lead.occupation;
        this.lead.workplace = data.lead.workplace;
        this.lead.intrestedProjects = data.lead.interested_project_id;
        this.lead.intrestedUnitTypes = data.lead.intrestedUnitTypes;
        this.lead.budget_from = data.lead.budget_from;
        this.lead.budget_to = data.lead.budget_to;
        this.lead.lead_source = data.lead.lead_source;
        this.lead.user_ids = data.lead.user_ids;
        // this.lead.agent_id = data.lead.agent_id;
        this.lead.date_of_birth = data.lead.date_of_birth;
        this.lead.address = data.lead.address;
        this.lead.comment = data.lead.comment;
        this.lead.lead_channel_id = data.lead.lead_channel_id;
        this.lead.phone_2 = data.lead.phone_2;
        this.lead.phone_3 = data.lead.phone_3;
        this.lead.phone_4 = data.lead.phone_4;
        this.lead.ambassador_id = data.lead.ambassador_id;
        this.lead.broker_id = data.lead.broker_id;
        this.lead.lead_event_id = data.lead.lead_event_id;
        this.lead.nationality = data.lead.nationality;
        this.lead.id_type = data.lead.id_type;
        this.lead.id_number = data.lead.id_number;

        console.log(this.lead.lead_source);
        this.calculatesChannelAndSources(
          data.lead.lead_channel_id,
          data.lead.lead_source
        );
        this.slimLoadingBarService.complete();
        this.getBrokers();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getGenders() {
    this.genders = null;
    this.genders = this.leadsService.getGenders();
  }

  clearControls() {
    this.lead = new Lead();
    this.lead.lead_source = "Self Generate";
    this.lead.gender = "Male";
    this.lead.user_ids = [];
    console.log("lead_source", this.lead.lead_source);
  }

  cancel() {}

  gotodashboard() {
    this.router.navigate(["/pages/leads"]);
  }
  require_channels = [];
  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = res;
        if (
          this.userData.is_sales_team ||
          this.userData.role == "Call Center"
        ) {
          this.channel = 1;
          this.channelChange(1);
        }
        this.require_channels.map((a) => a());
        this.require_channels = null;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  channelChange(_, change = true) {
    if (change) {
      this.lead.lead_source = -1;
    }
    if (Array.isArray(this.require_channels)) {
      this.require_channels.push(() => {
        this.channels.forEach((e) => {
          if (e.id == this.channel) {
            this.leadSources = [];
            if (change) {
              this.lead.lead_source = -1;
            }
            this.leadSources = e.sources;
            this.channelview = e.name;
            if (change && this.channelview != "Brokers") {
              if (this.lead.broker_id) {
                this.lead.broker_id = null;
              } else if (this.lead.ambassador_id) {
                this.lead.ambassador_id = null;
              }
            }
          }
        });
      });
    } else {
      this.channels.forEach((e) => {
        if (e.id == this.channel) {
          this.leadSources = [];
          if (change) {
            this.lead.lead_source = -1;
          }
          this.leadSources = e.sources;
          this.channelview = e.name;
          if (change && this.channelview != "Brokers") {
            if (this.lead.broker_id) {
              this.lead.broker_id = null;
            } else if (this.lead.ambassador_id) {
              this.lead.ambassador_id = null;
            }
          }
        }
      });
    }
  }

  getProjects() {
    this.projectsService.getProjects().subscribe(
      (data: any) => {
        this.projects = data;
        console.log(this.projects);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getTypes() {
    this.projectsService.getUnitTypes().subscribe((data: any) => {
      this.types = data;
    });
  }

  getBrokers() {
    let params: any = {};
    console.log(this.lead.user_ids);
    // if (this.userData.role != "Property Consultant") {
    //   if (
    //     !this.lead.user_ids ||
    //     (this.lead.user_ids && this.lead.user_ids.length === 0)
    //   ) {
    //     this.brokers = [];
    //     return;
    //   }
    //   params.user_id = this.lead.agent_id.id;
    // }
    this.slimLoadingBarService.start();
    this.userService.getBorkersByUser(params).subscribe(
      (data: any) => {
        this.brokers = data.filter((broker) => broker.name);
        console.log(this.brokers);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getAmbassadors() {
    this.slimLoadingBarService.start();
    this.userService.getAmbasdors().subscribe(
      (data: any) => {
        this.ambassadors = data;
        console.log(this.ambassadors);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  checkPhoneValid(event: any) {
    const pattren = /[0-9\+]/;
    console.log(event.keyCode);
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattren.test(inputChar)) {
      event.preventDefault();
    }
  }

  /*
   * Listen On Lead Source Select
   *
   * if select Broker -> Broker select will appear
   */
  changeLeadSource(ev) {
    console.log(ev);
    // if (ev == 'Broker') this.channelview = ev;
  }

  getEvents() {
    this.reservationService.getAllEvents().subscribe((res: any) => {
      this.events = res;
      console.log(res);
    });
  }

  getNationalities() {
    this.userService.getNationalities().subscribe((res: any) => {
      this.nationalities = res;
      console.log(this.nationalities);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/lead/addLead/addlead.component.ts